import React from 'react'
import { Grid } from '@mui/material'

import { DataBlock, RefundSbpButton } from '../../components'
import { SbpPayment } from '../../types.ts'

import {
  MAIN_INFO_LABELS,
  MONEY_INFO_LABELS,
  SENDER_INFO_B2B_LABELS,
  SENDER_INFO_C2B_LABELS,
  TSP_INFO_LABELS,
} from './constants.ts'

export interface OperationInfoProps {
  payment: SbpPayment
}

export const OperationInfoTab = ({ payment }: OperationInfoProps): React.ReactElement => {
  return (
    <Grid container flexDirection="row" spacing={{ xs: 2, lg: 4 }}>
      <Grid item xs={12} md={6}>
        <DataBlock items={MAIN_INFO_LABELS} data={payment}>
          {payment.canBeReversed && <RefundSbpButton {...payment} iconButton={false} />}
        </DataBlock>
      </Grid>
      <Grid item xs={12} md={6}>
        <DataBlock items={MONEY_INFO_LABELS} data={payment} />
      </Grid>
      <Grid item xs={12} lg={6}>
        <DataBlock items={TSP_INFO_LABELS} data={payment} />
      </Grid>
      <Grid item xs={12} lg={6}>
        <DataBlock
          items={payment.type === 'INCOME_B2B' ? SENDER_INFO_B2B_LABELS : SENDER_INFO_C2B_LABELS}
          data={payment}
        />
      </Grid>
    </Grid>
  )
}
